import { apiGetHelper } from 'utils/apiHelper'
import { appPrefix } from 'utils/browserHelper'
import { DOMAIN } from 'constants/base'

export const fetchUserProfileData = (itineraryId, userId) => {
    const URL = `${DOMAIN}/itin/v2/itinerary/${itineraryId}/user`
    // const URL = `http://localhost:3000/userProfile.json`
    const response = apiGetHelper(URL)
    return response
}
